
export default {
  namespaced: true,
  state: {
    menu: {},
    content: {}
  },
  mutations: {
    setMenu (state, menu) { state.menu = menu},
    setContent (state, content) { state.content = content}
  },
  getters: {
    getMenu: (state) => {
      return state.menu
    },
    getContent: (state) => {
      return state.content
    }
  },
  actions: {
    MenuStatusSet({commit}, values) {
      return new Promise(resolve => {
        commit('setMenu', values)
        resolve()
      })
    },
    ContentStatusSet({commit}, values) {
      return new Promise(resolve => {
        commit('setContent', values)
        resolve()
      })
    },
  }
}